module.exports = __webpack_public_path__ + "media/country_flags/er-96e3bd16.png";